export default __webpack_public_path__ + "static/media/check-grey.47217c6a.svg";